import React, { CSSProperties, forwardRef, ReactNode } from 'react';
import classNames from 'classnames';
import SimpleBar from 'simplebar-react';

import type { ScrollbarsRef } from './types';

import 'simplebar-react/dist/simplebar.min.css';
import styles from './Scrollbar.module.scss';

export type ScrollbarProps = {
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
};

export const Scrollbar = forwardRef<ScrollbarsRef, ScrollbarProps>((props, ref) => {
  const { className, ...rest } = props;

  const simpleBarClassNames = classNames(styles.scrollbarWrapper, className);

  return (
    <SimpleBar className={simpleBarClassNames}
               {...rest}
               ref={ref}>
      {props.children}
    </SimpleBar>
  );
});
